import { Button, Card, Label, Layout, Select, Text, TextField } from '@loadsmart/loadsmart-ui'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Drawer,
  Paper,
} from '@mui/material'
import CopyToClipboard from 'atoms/CopyToClipboard'
import {
  IntegrationTestCase,
  IntegrationTestCaseDetail,
} from 'common/types/kraken-core/IntegrationTest'
import { useIntegrationTestContext } from 'pages/IntegrationTest/IntegrationTestContext'
import { useEffect, useState } from 'react'
import IntegrationTestCaseDetailEntryPoint from './IntegrationTestCaseDetailEntryPoint'
import IntegrationTestCaseDetailInputtDefinition from './IntegrationTestCaseDetailInputDefinition'
import IntegrationTestCaseDetailExpectationDefinitionDetail from './IntegrationTestCaseExpectationDefinition'

export interface IntegrationTestCaseDetailProps {
  onClose?: () => void
}

export default function IntegrationTestCaseDetailDrawer(props: IntegrationTestCaseDetailProps) {
  const context = useIntegrationTestContext()
  const [localTestCase, setLocalTestCase] = useState<IntegrationTestCaseDetail>()

  const handleOnClose = () => {
    if (props.onClose) props.onClose()
    context.toggleTestCaseDetailView()
  }

  useEffect(() => {
    setLocalTestCase(context.testCase)
  }, [context.testCase])

  return (
    <Drawer
      open={context.isTestCaseDetailViewOpened}
      anchor="right"
      PaperProps={{
        style: {
          width: '50%',
        },
      }}
      onClose={handleOnClose}
    >
      {localTestCase ? (
        <Layout.Stack
          className="h-full"
          justify="space-between"
          style={{
            position: 'relative',
          }}
        >
          <Layout.Stack
            className="w-full"
            style={{
              position: 'relative',
            }}
          >
            <Layout.Stack
              style={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
              }}
            >
              <Paper elevation={0}>
                <Layout.Group className="p-6">
                  <Layout.Stack space="s">
                    <Text variant="heading-md-bold">{localTestCase.description}</Text>
                    <CopyToClipboard value={String(localTestCase.id)} />
                  </Layout.Stack>
                </Layout.Group>

                <Divider />
              </Paper>
            </Layout.Stack>

            <Layout.Stack className="p-4">
              <IntegrationTestCaseDetailEntryPoint
                testCase={localTestCase}
                onChange={(propertyName, value) => {
                  console.log(propertyName)
                }}
              />
              <IntegrationTestCaseDetailInputtDefinition
                testCase={localTestCase}
                onChange={(propertyName, value) => {
                  console.log(propertyName)
                }}
              />
              <IntegrationTestCaseDetailExpectationDefinitionDetail
                testCase={localTestCase}
                onChange={(propertyName, value) => {
                  console.log(propertyName)
                }}
              />
            </Layout.Stack>
          </Layout.Stack>

          <Layout.Stack
            style={{
              position: 'sticky',
              bottom: 0,
              zIndex: 1,
            }}
          >
            <Paper>
              <Divider />
              <Layout.Group className="p-6" justify="space-between">
                <Button onClick={handleOnClose}>Cancel</Button>
                <Button variant="primary">Save</Button>
              </Layout.Group>
            </Paper>
          </Layout.Stack>
        </Layout.Stack>
      ) : null}
    </Drawer>
  )
}
